import React from "react";
import {
  Tab as RootTab,
  Tabs as RootTabs,
  TabList as RootTabList,
  TabPanel as RootTabPanel
} from "react-tabs";

// Pretty sure it's because we're on React 15 (not 16) but we
// need to shim the tabs to make sure they focus correctly for accessible tabs
class FocusableTabs extends React.Component {
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedIndex !== this.props.selectedIndex) {
      this.tabs.querySelector('[aria-selected="true"]').focus();
    }
  }

  render() {
    return (
      <div
        style={{ display: "inline", height: "100%" }}
        ref={tabs => (this.tabs = tabs)}
      >
        <RootTabs {...this.props} />
      </div>
    );
  }
}

export const Tabs = FocusableTabs;
export const Tab = RootTab;
export const TabList = RootTabList;
export const TabPanel = RootTabPanel;
